import { Trans } from "@lingui/react/macro";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";

import { NotificationSettingsClient } from "@/components/account/notification-settings-client";
import { PROVIDER_CATEGORIES } from "@/lib/notifications/provider-categories";

/**
 * Provider-scoped notification preferences page.
 *
 * Renders the per-category × per-channel matrix for provider-scope
 * categories (booking requests, team changes, calendar sync, etc.).
 * Reminder timing + Web Push subscription management are user-scope
 * concepts and are hidden via `hideUserOnlyFeatures`.
 *
 * Backend endpoint: `/api/account/notification-preferences?scope=provider`
 * (Track 1). Component is refactored in Track 5 to accept `scope`,
 * `categories`, and `hideUserOnlyFeatures` props. Deep-link twin of the
 * Settings → Notifications tab (same scope + categories).
 */
export const Route = createFileRoute("/_authenticated/account/provider/settings/notifications")({
  component: ProviderNotificationsSettingsPage,
});

function ProviderNotificationsSettingsPage() {
  return (
    <div className="space-y-6">
      <Link
        to="/account/provider/settings"
        search={{ tab: "notifications" }}
        className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1 text-sm transition-colors"
      >
        <ChevronLeft className="size-4" />
        <Trans>Back to provider settings</Trans>
      </Link>
      <header>
        <h1 className="font-display text-foreground text-2xl font-semibold tracking-[-0.02em]">
          <Trans>Notification preferences</Trans>
        </h1>
        <p className="text-muted-foreground mt-1 text-sm">
          <Trans>
            Choose how Pontimed reaches you about provider activity — booking requests, team
            changes, calendar sync, payments, reviews, and clinic invitations.
          </Trans>
        </p>
      </header>
      <NotificationSettingsClient
        scope="provider"
        categories={PROVIDER_CATEGORIES}
        hideUserOnlyFeatures={true}
      />
    </div>
  );
}
